import { connect } from 'react-redux'
import { SummaryStepComponent } from './SummaryStep'

const stateToProps = () => ({})

const dispatchToProps = {}

export const SummaryStep = connect(
  stateToProps,
  dispatchToProps
)(SummaryStepComponent)



// WEBPACK FOOTER //
// src/features/MobileServices/MobileServiceForm/SummaryStep/SummaryStep.container.ts